"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const styled_components_1 = __importDefault(require("styled-components"));
const SketchCard_1 = __importDefault(require("../../molecules/SketchCard"));
const TextboxCard_1 = __importDefault(require("../../molecules/TextboxCard"));
const ImageCard_1 = __importDefault(require("../../molecules/ImageCard"));
const VideoCard_1 = __importDefault(require("../../molecules/VideoCard"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const hooks_1 = require("../../hooks");
function StickiesPanel({ stickies, className, selectedColor, selectedSize, setSelectedID, onDone, selectedToolType, setSelectedType, trigger, isEditable = true, }) {
    const selectedID = (0, hooks_1.useSelectedID)();
    if (!Array.isArray(stickies)) {
        return null;
    }
    if ((stickies === null || stickies === void 0 ? void 0 : stickies.length) === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'StickiesPanel_Container', children: stickies === null || stickies === void 0 ? void 0 : stickies.map(({ identifier, type, stickyRect, text, curves, image, videoLink }) => {
            if (type === bridge_schema_1.ToolType.StickyText && text !== undefined) {
                const selected = identifier === selectedID;
                return ((0, jsx_runtime_1.jsx)(TextboxCard_1.default, { identifier: identifier, text: text, rect: stickyRect, selected: selected, setSelectedID: setSelectedID, onDone: onDone, selectedTooltype: selectedToolType, setSelectedType: setSelectedType, trigger: trigger, "data-e2e": 'StickiesPanel_TextboxCard' }, identifier));
            }
            if (type === bridge_schema_1.ToolType.StickyHandWriting && curves !== undefined) {
                return ((0, jsx_runtime_1.jsx)(SketchCard_1.default, { identifier: identifier, curves: curves, rect: stickyRect, selectedToolType: selectedToolType, color: selectedColor, size: selectedSize, setSelectedID: setSelectedID, setSelectedType: setSelectedType, isEditable: isEditable, "data-e2e": 'StickiesPanel_SketchCard' }, identifier));
            }
            if (type === bridge_schema_1.ToolType.StickyImage && image !== undefined) {
                return ((0, jsx_runtime_1.jsx)(ImageCard_1.default, { identifier: identifier, image: image, rect: stickyRect, selectedToolType: selectedToolType, color: selectedColor, size: selectedSize, setSelectedID: setSelectedID, setSelectedType: setSelectedType, "data-e2e": 'StickiesPanel_ImageCard' }, identifier));
            }
            if (type === bridge_schema_1.ToolType.StickyVideo &&
                image !== undefined &&
                videoLink !== undefined) {
                return ((0, jsx_runtime_1.jsx)(VideoCard_1.default, { identifier: identifier, image: image, videoLink: videoLink, rect: stickyRect, selectedToolType: selectedToolType, color: selectedColor, size: selectedSize, setSelectedID: setSelectedID, setSelectedType: setSelectedType, "data-e2e": 'StickiesPanel_VideoCard' }, identifier));
            }
            return null;
        }) }));
}
exports.default = StickiesPanel;
const Container = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  user-select: none;
`;
